// [live-chat-split-change]
import React from 'react';
import { Provider } from 'mobx-react';
import clsx from 'classnames';
import coreStore from '@/stores/core';
import historyStore from '@/stores/history';
import SessionArea from '@/components/SessionArea';
import HistoryLoader from '@/components/History/Loader';
import PullToLoad, { PullToLoadStatus } from '@/components/PullToLoad';
import { scrollToBottom } from '@/utils/tools';
import { HISTORY_LOADING_HEIGHT } from '@/utils/constants';
import { getScrollElement } from '@/utils/instantLoaded/toolsWithoutDeps';

export default class ChatMessagesArea extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const scrollEle = getScrollElement();
    if (!scrollEle) {
      return;
    }
    scrollToBottom(true);
  }

  render() {
    const PullToLoadConfig = {
      id: 'global-scroll',
      className: clsx('global-scroll'),
      disabled: false,
      maxDistance: HISTORY_LOADING_HEIGHT,
      indicator: {
        [PullToLoadStatus.PENDING]: <HistoryLoader status={PullToLoadStatus.PENDING} />,
        [PullToLoadStatus.LOADING]: <HistoryLoader status={PullToLoadStatus.LOADING} />,
        [PullToLoadStatus.PULLING]: <HistoryLoader status={PullToLoadStatus.PULLING} />,
        [PullToLoadStatus.ACTIVE]: <HistoryLoader status={PullToLoadStatus.ACTIVE} />,
      },
      onLoad: historyStore.getChatHistory,
    };

    return (
      <Provider coreStore={coreStore}>
        <PullToLoad {...PullToLoadConfig}>
          <SessionArea />
        </PullToLoad>
      </Provider>
    );
  }
}
